function GetBaseUrl() {
  // const ApiEndpoint = "http://localhost:8080";
  const ApiEndpoint = "https://skills.buildfromzero.com";
  return ApiEndpoint;
}
export default GetBaseUrl;
